/**
 * ToggleButton
 * FALSE/TRUE toggle matching the legacy Strapi CMS pattern.
 * Used for isFeatured and isFeaturedForPro boolean fields.
 */

type ToggleButtonProps = {
  label: string;
  checked: boolean;
  onChange: (value: boolean) => void;
};

export function ToggleButton({ label, checked, onChange }: ToggleButtonProps) {
  return (
    <div className="flex items-center gap-2">
      <span className="text-sm text-gray-700">{label}</span>
      <div className="inline-flex rounded-md border border-gray-300 overflow-hidden">
        <button
          type="button"
          onClick={() => onChange(false)}
          className={`px-3 py-1 text-xs font-medium transition-colors ${
            !checked ? 'bg-gray-200 text-gray-800' : 'bg-white text-gray-400 hover:bg-gray-50'
          }`}
        >
          FALSE
        </button>
        <button
          type="button"
          onClick={() => onChange(true)}
          className={`px-3 py-1 text-xs font-medium transition-colors ${
            checked ? 'bg-[#026857] text-white' : 'bg-white text-gray-400 hover:bg-gray-50'
          }`}
        >
          TRUE
        </button>
      </div>
    </div>
  );
}
